import React from 'preact';
import { useState } from "preact/hooks";
import { useEffect } from "preact/compat";
import constants from "../../constants";

interface PriceNameLeftProps {
  active: boolean;
}

export default function PriceNameLeft({ active }: PriceNameLeftProps) {
  const [primaryColor, setPrimaryColor] = useState('');
  const [secondaryColor, setSecondaryColor] = useState('');

  useEffect(() => {
    if (active) {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
      setSecondaryColor(constants.PRICE_COLOR_SECONDARY_ACTIVE);
    } else {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_INACTIVE);
      setSecondaryColor(constants.PRICE_COLOR_SECONDARY_INACTIVE);
    }
  }, [active]);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 136 28.91">
      <g>
        <g>
          <path fill={secondaryColor} d="M0 14.91H136V19.91H0z" />
          <path fill={secondaryColor} d="M0 23.91H123V28.91H0z" />
          <path fill={primaryColor} d="M0 0.91H81V8.91H0z" />
          <path fill={primaryColor} d="M87.25 7v.82h-.86v-.81c-.95-.08-1.63-.44-2.12-.94l.69-.97c.34.35.83.66 1.43.76V4.45c-.93-.22-1.94-.58-1.94-1.8 0-.92.73-1.69 1.94-1.81V0h.86v.86c.73.07 1.34.36 1.83.8l-.71.94c-.31-.3-.71-.49-1.12-.58v1.26c.94.24 1.97.6 1.97 1.83 0 .99-.65 1.76-1.97 1.9zm-.77-3.92V1.94c-.46.04-.7.28-.7.6 0 .28.29.43.7.54zm1.44 2.16c0-.33-.31-.49-.75-.61v1.26c.51-.07.75-.35.75-.65z" />
        </g>
      </g>
    </svg>
  );
}